import { createSlice, createAction } from '@reduxjs/toolkit';

export const createShiftApplicationsReportAction = createAction(
    'shiftApplicationsReports/createReport',
);
export const fetchShiftApplicationsReportsAction = createAction(
    'shiftApplicationsReports/fetchReports',
);
export const pollShiftApplicationsReportStatusAction = createAction(
    'shiftApplicationsReports/pollReportStatus',
);
export const stopShiftApplicationsPollingAction = createAction(
    'shiftApplicationsReports/stopPolling',
);
export const checkExistingShiftApplicationsReportAction = createAction(
    'shiftApplicationsReports/checkExisting',
);
export const deleteShiftApplicationsReportAction = createAction(
    'shiftApplicationsReports/deleteReport',
);

const initialState = {
    reports: [],
    total: 0,
    loading: false,
    creating: false,
    activeReport: null,
    existingReport: null,
    checkingExisting: false,
    error: null,
};

const shiftApplicationsReportsSlice = createSlice({
    name: 'shiftApplicationsReports',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setCreating(state, action) {
            state.creating = action.payload;
        },
        reportsFetched(state, action) {
            state.reports = action.payload.reports;
            state.total = action.payload.total;
            state.loading = false;
        },
        reportCreated(state, action) {
            state.creating = false;
            state.activeReport = action.payload;
            state.reports = [action.payload, ...state.reports];
            state.total += 1;
        },
        reportStatusUpdated(state, action) {
            const report = action.payload;
            state.activeReport = report;
            const idx = state.reports.findIndex(r => r._id === report._id);
            if (idx !== -1) {
                state.reports[idx] = report;
            }
        },
        clearActiveReport(state) {
            state.activeReport = null;
        },
        setExistingReport(state, action) {
            state.existingReport = action.payload;
            state.checkingExisting = false;
        },
        setCheckingExisting(state, action) {
            state.checkingExisting = action.payload;
        },
        reportDeleted(state, action) {
            state.reports = state.reports.filter(r => r._id !== action.payload);
            state.total = Math.max(0, state.total - 1);
        },
        setError(state, action) {
            state.error = action.payload;
            state.loading = false;
            state.creating = false;
        },
    },
});

export const {
    setLoading,
    setCreating,
    reportsFetched,
    reportCreated,
    reportStatusUpdated,
    clearActiveReport,
    reportDeleted,
    setExistingReport,
    setCheckingExisting,
    setError,
} = shiftApplicationsReportsSlice.actions;

export const getShiftApplicationsReports = state =>
    state.shiftApplicationsReports.reports;
export const getShiftApplicationsReportsTotal = state =>
    state.shiftApplicationsReports.total;
export const getShiftApplicationsReportsLoading = state =>
    state.shiftApplicationsReports.loading;
export const getShiftApplicationsReportsCreating = state =>
    state.shiftApplicationsReports.creating;
export const getActiveShiftApplicationsReport = state =>
    state.shiftApplicationsReports.activeReport;
export const getExistingShiftApplicationsReport = state =>
    state.shiftApplicationsReports.existingReport;
export const getCheckingExistingShiftApplications = state =>
    state.shiftApplicationsReports.checkingExisting;

export default shiftApplicationsReportsSlice.reducer;
